//@ts-nocheck
import { useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';
import { BailetsBlock } from '../../ModalCopy.styles';
import { CloseVideoIcon, LogoMartins } from '@assets/svgs';
import { Python1, Python2, Python3, Python4 } from './codes';

type ApiDocumentsProps = {
  isClosed?: () => void;
  showImg?: boolean | string;
  showMedia?: boolean | string;
};

export const PythonDocuments = ({
  isClosed,
  showImg,
  showMedia
}: ApiDocumentsProps) => {
  const [pValue] = useState(20);
  const [sValue] = useState(12);
  const [mBottom] = useState(5);

  return (
    <>
      <BailetsBlock>
        <CloseVideoIcon
          animation="closeIcon"
          color="#000"
          isActive={isClosed}
        />
        <LogoMartins
          width={70}
          height={65}
          color="rgba(0,0,0,0.5)"
          animation="mansion"
        />

        <h3>NEXT.JS AND PYTHON</h3>
        <span style={{ marginBottom: '25px', fontWeight: '400' }}>
          TECHNICAL DOCUMENTATION / FRONT END AND BACK END APPS
        </span>
        {showImg && <Image src={showImg} width={1480} height={825} alt="" />}
        {showMedia && (
          <video
            controlsList="nodownload"
            controls={true}
            playsInline
            muted
            autoPlay
            loop
          >
            <source src={showMedia} type="video/mp4" />
          </video>
        )}

        <h2 className="markTitle" style={{ marginTop: '30px' }}>
          Contents
        </h2>
        <p
          style={{ textAlign: 'left', width: '100%', marginTop: `${pValue}px` }}
        >
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>1- Introduction</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            1.1- Purpose
          </span>
          <span style={{ paddingLeft: `${pValue + pValue}px` }}>
            1.2- Overview of Next.js and Python
          </span>
          <br />
          <br />
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>2- Prerequisites</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            2.1- Software Requirements
          </span>
          <span style={{ paddingLeft: `${pValue + pValue}px` }}>
            2.2- Basic Knowledge
          </span>
          <br />
          <br />
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>3- Setting Up the Environment</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            3.1- Installing Node.js and npm
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            3.2- Installing Python and pip
          </span>
          <span style={{ paddingLeft: `${pValue + pValue}px` }}>
            3.3- Setting Up a Virtual Environment (Python)
          </span>
          <br />
          <br />
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>4- Creating the Next.js Frontend</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            4.1- Initializing a Next.js Project
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            4.2- Creating Pages
          </span>
          <span style={{ paddingLeft: `${pValue + pValue}px` }}>
            4.3- Fetching Data from Backend API
          </span>
          <br />
          <br />
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>5- Building the Python Backend</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            5.1- Setting Up a Flask API
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            5.2- Creating API Endpoints
          </span>
          <span style={{ paddingLeft: `${pValue + pValue}px` }}>
            5.3- Running the Python Backend
          </span>
          <br />
          <br />
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>6- Integrating Frontend with Backend</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            6.1- Connecting Next.js with Python API
          </span>
          <span style={{ paddingLeft: `${pValue + pValue}px` }}>
            6.2- Testing API Calls
          </span>
          <br />
          <br />
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>7- Deploying the Application</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            7.1- Deploying Next.js Frontend
          </span>
          <span style={{ paddingLeft: `${pValue + pValue}px` }}>
            7.2- Deploying Python Backend
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            <b>8- Conclusion</b>
          </span>
          <br />
          <br />
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>9- Appendix</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            9.1- Useful Commands
          </span>
          <span style={{ paddingLeft: `${pValue + pValue}px` }}>
            9.2- Additional Resources
          </span>
          <br />
          <br />
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h2 className="markTitle">1. Introduction</h2>
        <p style={{ textAlign: 'left' }}>
          <b>1.1- Purpose</b>
          <br />
          This document provides a step-by-step guide to building a full-stack
          web application using Next.js for the frontend and Python (with Flask)
          for the backend. It is designed for both software engineers and
          non-technical individuals interested in learning the basics of web
          development.
          <br />
          <br />
          <b>1.2- Overview of Next.js and Python</b>
          <br />
          <b>1.2.1- Next.js:</b> A React-based framework that enables
          server-side rendering, static site generation, and client-side
          navigation, making it ideal for building fast and SEO-friendly web
          applications.
          <br />
          <br />
          <b>1.2.2- Python:</b> A versatile programming language. Here, we'll
          use Flask, a lightweight web framework, to build APIs for our backend.
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h2 className="markTitle">2. Prerequisites</h2>
        <p style={{ width: '100%', textAlign: 'left' }}>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>2.1- Software Requirements</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>2.1.1- Node.js</b> (v14.x or later)
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>2.1.2- npm</b> (v6.x or later, typically installed with Node.js)
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>2.1.3- Python</b> (v3.8 or later)
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>2.1.4- pip</b> (Python's package installer)
          </span>
          <br />
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>2.2- Basic Knowledge</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>2.2.1- Software Engineers:</b> Familiarity with JavaScript,
            React, Python, and basic concepts of REST APIs.
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>2.2.2- Non-technical people:</b> Basic understanding of web
            browsers, the command line, and text editing.
          </span>
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h2 className="markTitle">3. Setting Up the Environment</h2>
        <p style={{ width: '100%', textAlign: 'left' }}>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>3.1- Installing Node.js and npm</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>3.1.1- Windows/macOS/Linux:</b> Download and install Node.js from
            the{' '}
            <a
              href="https://nodejs.org/en"
              target="_blank"
              style={{ color: '#2e95d3' }}
            >
              official website
            </a>
            . This will also install npm.
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>3.1.2- Verify Installation on your terminal:</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              display: 'block'
            }}
          >
            <code>node -v</code>
            <br />
            <code>npm -v</code>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              display: 'block'
            }}
          >
            You should see the installed versions of Node.js and npm.
          </span>
          <br />
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>3.2- Installing Python and pip</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>3.2.1- Windows/macOS/Linux:</b> Download and install Python from
            the{' '}
            <a
              href="https://www.python.org/"
              target="_blank"
              style={{ color: '#2e95d3' }}
            >
              official website
            </a>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>3.2.2- Verify Installation on your terminal:</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              display: 'block'
            }}
          >
            <code>python --version</code>
            <br />
            <code>pip --version</code>
          </span>
          <br />
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>3.3- Setting Up a Virtual Environment (Python)</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>3.3.1- Create a virtual environment:</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom + mBottom + mBottom}px`,
              display: 'block'
            }}
          >
            <code>python -m venv venv</code>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>3.3.2- Activate the virtual environment:</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>3.3.2.1- Windows:</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue + pValue}px`,
              marginBottom: `${mBottom + mBottom + mBottom}px`,
              display: 'block'
            }}
          >
            <code>.\venv\Scripts\activate</code>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>3.3.2.2- macOS/Linux:</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue + pValue}px`,
              marginBottom: `${mBottom + mBottom + mBottom}px`,
              display: 'block'
            }}
          >
            <code>source venv/bin/activate</code>
          </span>

          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>3.3.3- Install Flask:</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue + pValue}px`,
              display: 'block'
            }}
          >
            <code>pip install Flask</code>
          </span>
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h2 className="markTitle">4. Creating the Next.js Frontend</h2>
        <p style={{ width: '100%', textAlign: 'left' }}>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>4.1- Initializing a Next.js Project</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>4.1.1- Create a new Next.js application:</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom + mBottom + mBottom}px`,
              display: 'block'
            }}
          >
            <code>npx create-next-app@latest my-nextjs-app</code>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>4.1.2- Navigate to the project directory:</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom + mBottom + mBottom}px`,
              display: 'block'
            }}
          >
            <code>cd my-nextjs-app</code>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>4.1.3- Run the development server:</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom + mBottom + mBottom}px`,
              display: 'block'
            }}
          >
            <code>npm run dev</code>
            <br />
            Open http://localhost:3000 in your browser to view your Next.js app.
          </span>

          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>4.2- Creating Pages</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>4.2.1- Create a new page:</b> In the <code>pages</code>{' '}
            directory, create a new file <code>about.ts</code>.
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>4.2.1- Add content:</b>
          </span>
          <Python1 paddValue={pValue + pValue} />
          <br />
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>4.3- Fetching Data from Backend API</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>4.3.1- Fetch data:</b> Update <code>index.js</code> to fetch data
            from the API..
          </span>
          <Python2 paddValue={pValue + pValue} />
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h2 className="markTitle">5. Building the Python Backend</h2>
        <p style={{ width: '100%', textAlign: 'left' }}>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>5.1- Setting Up a Flask API</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>5.1.1- Create a new file:</b> <code>app.py</code>.
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>5.1.1- Set up Flask:</b>.
          </span>
          <Python3 paddValue={pValue + pValue} />
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>5.2- Creating API Endpoints</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>5.2.1-</b> Add more routes to handle different data requests.
          </span>
          <Python4 paddValue={pValue + pValue} />
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>5.3- Running the Python Backend</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>5.3.1-</b> Run the Flask server:
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <code>python app.py</code>
            <br />
            Your backend will be running at http://localhost:5000.
          </span>
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h2 className="markTitle">6. Integrating Frontend with Backend</h2>
        <p style={{ width: '100%', textAlign: 'left' }}>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>6.1- Connecting Next.js with Python API</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>6.1.1-</b> Update API URL in <code>index.js</code> to point to
            your Flask backend:
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom + mBottom + mBottom}px`,
              display: 'block'
            }}
          >
            <code>
              const res = await fetch('http://localhost:5000/api/data');
            </code>
          </span>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>6.2- Testing API Calls</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>6.2.1- Check the console/logs</b> for any errors in fetching
            data.
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>6.2.2- Open your Next.js app</b> in a browser and ensure data is
            displayed correctly.
          </span>
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h2 className="markTitle">7. Deploying the Application</h2>
        <p style={{ width: '100%', textAlign: 'left' }}>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>7.1- Deploying Next.js Frontend</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>7.1.1- Build your Next.js application:</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <code>npm run build</code>
            <br />
            <code>npm run start</code>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>7.1.2- Deploy to Vercel:</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            7.1.2.1- Sign up on{' '}
            <a
              href="https://vercel.com/"
              style={{ color: '#2e95d3' }}
              target="_blank"
            >
              Vercel
            </a>
            .
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue + pValue}px`,
              marginBottom: `${mBottom + mBottom + mBottom}px`,
              display: 'block'
            }}
          >
            7.1.2.2- Connect your GitHub repository and deploy.
          </span>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>7.2- Deploying Python Backend</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>7.2.1- Deploy using Heroku:</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            7.2.1.1- Create a Procfile with the following content:
            <br />
            <code>web: python app.py</code>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue + pValue}px`,
              marginBottom: `${mBottom + mBottom + mBottom}px`,
              display: 'block'
            }}
          >
            7.2.1.2- Use the Heroku CLI to create an app and deploy.
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>7.2.2- Deploy using other cloud providers:</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue + pValue}px`,
              display: 'block'
            }}
          >
            7.2.2.1- Explore platforms like AWS, Azure, or Google Cloud.
          </span>
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h2 className="markTitle">8. Conclusion</h2>
        <p style={{ width: '100%', textAlign: 'left' }}>
          You have successfully created a full-stack web application using
          Next.js for the frontend and Python (Flask) for the backend. This
          application can now be expanded with more features and deployed to
          production for real-world use.
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h2 className="markTitle">9. Appendix</h2>
        <p style={{ width: '100%', textAlign: 'left' }}>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>9.1- Useful Commands</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>9.1.1 Next.js:</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            9.1.1.1- Start development server: <code>npm run dev</code>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue + pValue}px`,
              marginBottom: `${mBottom + mBottom + mBottom}px`,
              display: 'block'
            }}
          >
            9.1.1.2- Build for production: <code>npm run build</code>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>9.1.2 Python:</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            9.1.2.1- Run Flask server: <code>python app.py</code>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>9.1.2.2- Activate virtual environment:</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue + pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            9.1.2.2.1- Windows: <code>.\venv\Scripts\activate</code>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue + pValue + pValue}px`,
              marginBottom: `${mBottom + mBottom + mBottom}px`,
              display: 'block'
            }}
          >
            9.1.2.2.2- macOS/Linux: <code>source venv/bin/activate</code>
          </span>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <b>9.2- Additional Resources</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <a
              href="https://nextjs.org/docs"
              style={{ color: '#2e95d3' }}
              target="_blank"
            >
              Next.js Documentation
            </a>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <a
              href="https://flask.palletsprojects.com/en/3.0.x/"
              style={{ color: '#2e95d3' }}
              target="_blank"
            >
              Flask Documentation
            </a>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <a
              href="https://vercel.com/docs"
              style={{ color: '#2e95d3' }}
              target="_blank"
            >
              Vercel Deployment Guide
            </a>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginBottom: `${mBottom}px`,
              display: 'block'
            }}
          >
            <a
              href="https://docs.controlplane.com/whatis"
              style={{ color: '#2e95d3' }}
              target="_blank"
            >
              Heroku Deployment Guide
            </a>
          </span>
          <br />
          <br />
          This document should help both technical and non-technical people
          understand the process of building a full-stack web application using
          Next.js and Python. With the step-by-step guide, even those with
          minimal coding experience can follow along and create a working
          application.
        </p>
      </BailetsBlock>
    </>
  );
};
